import { c as _c } from "react/compiler-runtime";
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import rehypeSanitize from 'rehype-sanitize';
import remarkGfm from 'remark-gfm';
export function Markdown(t0) {
  const $ = _c(5);
  const {
    text
  } = t0;
  let t1;
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [rehypeRaw, rehypeSanitize];
    t2 = [remarkGfm];
    t3 = {
      a: _temp
    };
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
  } else {
    t1 = $[0];
    t2 = $[1];
    t3 = $[2];
  }
  let t4;
  if ($[3] !== text) {
    t4 = <ReactMarkdown rehypePlugins={t1} remarkPlugins={t2} components={t3}>{text}</ReactMarkdown>;
    $[3] = text;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
}
function _temp(t0) {
  const {
    node,
    ...props
  } = t0;
  return <a {...props} target="_blank" rel="noopener noreferrer" />;
}